import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ImporterModalBrowserSelected = ({
  selectedFolders,
  selectedFiles,
}) => {
  const intl = useIntl();

  return (
    <div className="modal-import-browser-selected">
      {(selectedFiles > 0 || selectedFolders > 0) && (
        <span>
          {intl.formatMessage({ defaultMessage: 'Selected:' })}
          {selectedFolders > 0 && (
            <span className="selected-number">
              <i className="fa-regular fa-folder-closed" />
              {selectedFolders}
            </span>
          )}
          {selectedFiles > 0 && (
            <span className="selected-number">
              <i className="fa-regular fa-file" />
              {selectedFiles}
            </span>
          )}
        </span>
      )}
    </div>
  );
};

ImporterModalBrowserSelected.propTypes = {
  selectedFolders: PropTypes.number.isRequired,
  selectedFiles: PropTypes.number.isRequired,
};

export default ImporterModalBrowserSelected;
